// Saint Louis University's undergraduate majors (#2743). Read on 2026-10-01
// from the official Academic Catalog's Degrees and Programs page
// (catalog.slu.edu/programs), whose filters tag each program by type and by
// college or school. Kept: every program tagged Bachelor's, under the
// catalog's own college or school name (its filter labels: Arts and
// Sciences, Business, ...). Left out: the accelerated bachelor's-to-graduate
// and dual-degree tracks (their bachelor's majors are listed on their own),
// the Accelerated and RN to B.S.N. nursing programs (for students who
// already hold a degree or an RN), the Archdiocesan version of Philosophy
// for Ministry, the Doctor of Physical Therapy and one Ph.D. the Bachelor's
// filter also tags. Added by hand: Occupational Science, B.S., which the
// catalog lists only as "Occupational Science, B.S. to Master of
// Occupational Therapy Accelerated Program", and Teaching, B.A. (Online).
// Programs the catalog tags "Available Fully Online" carry that as a note.
// Degree abbreviations are the catalog's own (B.A., B.S., B.S.B.A.). The
// KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "saint-louis-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Saint Louis University's official Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates, accelerated bachelor's-to-graduate tracks and graduate programs are left out.",
    "groups": [
        {
            "name": "Arts and Sciences",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Bioethics and Health Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Forensic Science",
                    "degree": "B.S."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Modern Languages and Intercultural Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theological Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Business",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Technology Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Leadership and Human Resource Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Sports Business",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "Education",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Education",
                    "degree": "B.A."
                },
                {
                    "name": "Teaching",
                    "degree": "B.A.",
                    "note": "Offered fully online."
                }
            ]
        },
        {
            "name": "Health Sciences",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Magnetic Resonance Imaging",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Nuclear Medicine Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Radiation Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Occupational Science",
                    "degree": "B.S.",
                    "note": "The catalog lists it as Occupational Science, B.S. to Master of Occupational Therapy Accelerated Program."
                }
            ]
        },
        {
            "name": "Nursing",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Philosophy and Letters",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Catholic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy for Ministry",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy for Ministry",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Professional Studies",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Computer Information Systems",
                    "degree": "B.S.",
                    "note": "Offered fully online."
                },
                {
                    "name": "General Studies",
                    "degree": "B.A.",
                    "note": "Offered fully online."
                },
                {
                    "name": "Leadership and Organizational Behavior",
                    "degree": "B.A.",
                    "note": "Offered fully online."
                },
                {
                    "name": "Project Management",
                    "degree": "B.S.",
                    "note": "Offered fully online."
                },
                {
                    "name": "Security and Strategic Intelligence",
                    "degree": "B.S.",
                    "note": "Offered fully online."
                },
                {
                    "name": "Technology and Leadership",
                    "degree": "B.S.",
                    "note": "Offered fully online."
                }
            ]
        },
        {
            "name": "Public Health and Social Justice",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Health Management",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Science and Engineering",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Aeronautics",
                    "degree": "B.S."
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Biology and Pharmacology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science + Art",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science + Computer Engineering",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science + Health Information Management",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science + Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science + Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science + Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science + Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geoinformatics and Geospatial Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Social Work",
            "source": {
                "label": "Saint Louis University Academic Catalog, Degrees and Programs",
                "url": "https://catalog.slu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
